/* src/app/layout/table-standard-layout/table-standard-layout.component.css */
.standard-table {
  width: 100%;
}
.row-action-buttons-cell {
  text-align: right;
}
.table-container {
  overflow-y: hidden;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  position: relative;
}
.center {
  text-align: center;
}
.right {
  text-align: right;
}
.table-scroll {
  max-height: 100%;
  overflow-y: auto;
  overflow-x: scroll;
  border: 1px solid #ccc;
}
mat-cell:nth-child(1),
mat-header-cell:nth-child(1) {
  flex: 0 0 30%;
}
mat-cell:nth-child(5),
mat-header-cell:nth-child(5) {
  flex: 0 0 10%;
}
table {
  border-collapse: collapse;
  overflow-y: hidden;
}
@media (max-width: 768px) {
  .table-scroll {
    max-height: 300px;
  }
}
@media only screen and (min-width: 500px) {
  .table-container {
    margin: 20px;
    border-radius: 0px;
  }
}
.search-field {
  margin-bottom: 0px;
  padding-bottom: 0px;
  height: 74px;
  margin-top: -5px;
  margin-left: -2px;
}
@media screen and (max-width: 600px) {
  .search-field {
    margin-top: -9px;
  }
}
.filter {
  display: block;
  position: absolute;
  top: 1px;
  left: 1px;
}
::ng-deep .filter .mat-form-field-infix {
  margin: 0px;
  padding: 0px;
  border-radius: 0px;
}
::ng-deep .filter .mat-mdc-input-element {
  font-size: 20pt;
  margin-left: 10px;
  padding: 2px;
  background: none;
  border-radius: 0px !important;
}
::ng-deep .filter .mat-icon {
  color: rgba(0, 0, 0, 0.4);
}
.white-background .mat-mdc-input-element {
  background: white;
}
::ng-deep .filter .mat-mdc-input-element:focus {
  background: white;
}
::ng-deep .filter .mat-form-field-underline {
  visibility: hidden !important;
}
::ng-deep .filter .mat-form-field-label-wrapper {
  margin: 0px;
  padding: 0px;
}
.topbar-action-buttons {
  display: block;
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 25px;
}
.topbar-action-export {
  display: block;
  position: absolute;
  top: 20px;
  right: 90px;
  font-size: 25px;
  cursor: pointer;
}
.mobile {
  font-size: 11px;
}
.gray {
  background-color: rgb(232, 232, 232);
  font-weight: bold;
}
.live-badge {
  color: #2e7d32;
  font-weight: 600;
}
.clear {
  cursor: pointer;
  display: inline;
  padding-left: 10px;
}
.title {
  padding-top: 10px;
  display: inline-block;
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  min-height: 45px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}
/*# sourceMappingURL=table-standard-layout.component.css.map */
